// eslint-disable-next-line import/prefer-default-export
export const PAGE_DEFAULT = { name: 'home' };
